import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import('@/components/home');
const chuangzuo_download = () => import('@/components/chuangzuo_download');
const Creation = () => import('@/components/Creation');
const Teaching = () => import('@/components/Teaching');
const create = () => import('@/components/create');
const tuijian = () => import('@/components/tuijian');
const VideoInfo = () => import('@/components/VideoInfo');
const all_works = () => import('@/components/all_works');
const hot = () => import('@/components/hot');
const idiom = () => import('@/components/idiom');
const news_list = () => import('@/components/news_list');
const news_info = () => import('@/components/news_info');
const school_list = () => import('@/components/school_list');
const SchoolInfo = () => import('@/components/SchoolInfo');
const team = () => import('@/components/team');
// const jiaoshi = () => import('@/components/jiaoshi');
// const kc1 = () => import('@/components/kc1');
// const kc2 = () => import('@/components/kc2');
// const kc3 = () => import('@/components/kc3');
const PinPai = () => import('@/components/PinPai');
// const join = () => import('@/components/join');
// const join_info = () => import('@/components/join_info');
// const join_info1 = () => import('@/components/join_info1');
// const join_info2 = () => import('@/components/join_info2');
// const touzi = () => import('@/components/touzi');
// const contact = () => import('@/components/contact');
const phoneLogin = () => import('@/components/phoneLogin');
const my_works = () => import('@/components/my_works');
const ziliao = () => import('@/components/ziliao');
const ChangePassword = () => import('@/components/ChangePassword');
const personalCenter = () => import('@/components/personalCenter');
const my_product = () => import('@/components/my_product');
// const renzheng = () => import('@/components/renzheng');
const act_code = () => import('@/components/act_code');
const teacher_download = () => import('@/components/teacher_download');
// const test = () => import('@/components/test');
// const act_code1 = () => import('@/components/act_code1');
const read = () => import('@/components/read');
const coursedetails = () => import('@/components/coursedetails');
const ListenCourse = () => import('@/components/ListenCourse');
// const BookList = () => import('@/components/BookList');
// const MyLess = () => import('@/components/MyLess');
const tiaozhuan = () => import('@/components/tiaozhuan');
const AppDownload = () => import('@/components/AppDownload');
const teacherPolicy = () => import('@/components/teacherPolicy');
const appPolicy = () => import('@/components/appPolicy');
const phoneRegister = () => import('@/components/phoneRegister');
const binding = () => import('@/components/binding');
const forgetPassword = () => import('@/components/forgetPassword');
const thirdPartyBinding = () => import('@/components/thirdPartyBinding');
const policy = () => import('@/components/policy');
const agreement = () => import('@/components/agreement');
const softwareDownload = () => import('@/components/softwareDownload');
const productPage = () => import('@/components/productPage');
const productTutorial = () => import('@/components/productTutorial');
const productTutorialInfo = () => import('@/components/productTutorialInfo');
const question = () => import('@/components/question');
const questionInfo = () => import('@/components/questionInfo');
const lessonSelection = () => import('@/components/lessonSelection');
const lessonSelectionInfo = () => import('@/components/lessonSelectionInfo');
const expertForm = () => import('@/components/expertForm');
const expertFormList = () => import('@/components/expertFormList');
const expertFormInfo = () => import('@/components/expertFormInfo');
const treasureBox = () => import('@/components/treasureBox');
const maJixingClass = () => import('@/components/maJixingClass');
const synchronousClassroom = () => import('@/components/synchronousClassroom');
const ducation_platform = () => import('@/components/ducation_platform');

const pdf = () => import('@/components/pdf');

Vue.use(Router);
const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      component: Home,
      meta: {
        title: "麻吉星・MAJIXING"
      }
    },
    {
      path: '/thirdPartyBinding',
      component: thirdPartyBinding,
      meta: {
        title: "第三方绑定",
        is_foot:true,
        needLogin: 1
      }
    },
    {
      path: '/ducationPlatform',
      component: ducation_platform,
      meta: {
        title: "麻吉星教发平台"
      }
    },
    {
      path: '/Creation',
      component: Creation,
      meta: {
        title: "麻吉星创作系统"
      }
    },
    {
      path: '/teacherPolicy',
      component: teacherPolicy,
      meta: {
        title: "魔法教师隐私政策"
      }
    },
    {
      name: 'appPolicy',
      path: '/appPolicy',
      component: appPolicy,
      meta: {
        title: "麻吉星App隐私政策"
      }
    },
    {
      path: '/AppDownload',
      component: AppDownload,
      meta: {
        title: "麻吉星魔法教师APP"
      }
    },
    {
      path: '/treasureBox',
      component: treasureBox,
      meta: {
        title: "麻吉星百宝盒"
      }
    },
    {
      path: '/maJixingClass',
      component: maJixingClass,
      meta: {
        title: "麻吉星班级"
      }
    },
    {
      path: '/synchronousClassroom',
      component: synchronousClassroom,
      meta: {
        title: "麻吉星同步课堂"
      }
    },
    {
      path: '/chuangzuo_download',
      component: chuangzuo_download,
      meta: {
        title: "麻吉星创作系统"
      }
    },
    {
      path: '/Teaching',
      component: Teaching,
      meta: {
        title: "麻吉星教学系统"
      }
    },
    {
      path: '/teacher_download',
      component: teacher_download,
      meta: {
        title: "麻吉星教学系统"
      }
    },
    {
      path: '/create',
      component: create,
      meta: {
        title: "全部作品—麻吉星MAJIXING"
      }
    },
    {
      path: '/AllWork',
      name: tuijian,
      component: tuijian,
      meta: {
        title: "推荐作品—麻吉星MAJIXING"
      }
    },
    {
      path: '/VideoInfo',
      name: 'VideoInfo',
      component: VideoInfo,
      meta: {
        title: "作品详情",
        needQuery:true
      }
    },
    {
      path: '/all_works',
      component: all_works,
      meta: {
        title: "全部作品"
      }
    },
    {
      path: '/hot',
      component: hot,
      meta: {
        title: "本月热门—麻吉星MAJIXING"
      }
    },
    {
      path: '/idiom',
      component: idiom,
      meta: {
        title: "成语中国—麻吉星MAJIXING"
      }
    },

    {
      path: '/news_list',
      name:'news_list',
      component: news_list,
      meta: {
        title: "麻吉星动态"
      }
    },
    {
      path: '/news_info',
      name: 'news_info',
      component: news_info,
      meta: {
        title: "麻吉星动态",
        needQuery:true
      }
    },

    {
      path: '/SchoolList',
      component: school_list,
      meta: {
        title: "麻吉星学校"
      }
    },
    {
      path: '/SchoolInfo',
      name: 'SchoolInfo',
      component: SchoolInfo,
      meta: {
        title: "麻吉星学校",
        needQuery:true
      }
    },

    {
      path: '/team:id',
      component: team,
      name:'team',
      meta: {
        title: "麻吉星团队"
      }
    },

    // {
    //   path: '/jiaoshi',
    //   component: jiaoshi,
    //   meta: {
    //     title: "麻吉星团队"
    //   }
    // },


    // {
    //   path: '/Course',
    //   component: kc1,
    //   meta: {
    //     title: "课程资源—麻吉星MAJIXING"
    //   }
    // },
    //
    // {
    //   path: '/kc2',
    //   component: kc2,
    //   meta: {
    //     title: "课程资源—麻吉星MAJIXING "
    //   }
    // },
    //
    // {
    //   path: '/kc3',
    //   component: kc3,
    //   meta: {
    //     title: "课程资源—麻吉星MAJIXING"
    //   }
    // },

    {
      path: '/PinPai:id',
      component: PinPai,
      name:'PinPai',
      meta: {
        title: "品牌故事—麻吉星MAJIXING"
      }
    },
    // {
    //   path: '/join',
    //   component: join,
    //   meta: {
    //     title: "加入我们—麻吉星MAJIXING"
    //   }
    // },
    //
    // {
    //   path: '/join_info',
    //   component: join_info,
    //   meta: {
    //     title: "加入我们—麻吉星MAJIXING"
    //   }
    // },
    // {
    //   path: '/join_info1',
    //   component: join_info1,
    //   meta: {
    //     title: "加入我们—麻吉星MAJIXING"
    //   }
    // },
    // {
    //   path: '/join_info2',
    //   component: join_info2,
    //   meta: {
    //     title: "加入我们—麻吉星MAJIXING"
    //   }
    // },
    // {
    //   path: '/touzi',
    //   component: touzi,
    //   meta: {
    //     title: "投资我们—麻吉星MAJIXING"
    //   }
    // },
    // {
    //   path: '/contact',
    //   component: contact,
    //   meta: {
    //     title: "留言板"
    //   }
    // },

    {
      path: '/login',
      name: 'login',
      component: phoneLogin,
      meta: {
        title: "登录",
        is_foot:true,
        needLogin: 1
      }
    },
    {
      path: '/register',
      component: phoneRegister,
      meta: {
        title: "注册",
        is_foot:true,
        needLogin: 1
      }
    },
    {
      path: '/binding',
      component: binding,
      meta: {
        title: "绑定",
        is_foot:true,
        needLogin: 1
      }
    },
    {
      path: '/forgetPassword',
      component: forgetPassword,
      meta: {
        title: "忘记密码",
        is_foot:true,
        needLogin: 1
      }
    },
    {
      path: '/my_works',
      component: my_works,
      meta: {
        title: "我的作品—麻吉星MAJIXING",
        needLogin: 2 //需要加校检判断的路由
      },
    },

    // {
    //   path: '/ModifyInformation',
    //   component: ziliao,
    //   meta: {
    //     title: "我的资料—麻吉星MAJIXING"
    //   }
    // },
    // {
    //   path: '/renzheng',
    //   component: renzheng,
    //   meta: {
    //     title: "认证中心"
    //   }
    // },
    {
      path: '/ChangePassword',
      component: ChangePassword,
      meta: {
        title: "修改密码"
      }
    },
    {
      path: '/personalCenter',
      component: personalCenter,
      meta: {
        title: "个人中心"
      }
    },
    {
      path: '/my_product',
      component: my_product,
      meta: {
        title: "我的作品"
      }
    },
    {
      path: '/act_code',
      component: act_code,
      meta: {
        title: "在线激活"
      }
    },
    {
      path: '/Creation/teacher_download',
      component: teacher_download,
      meta: {
        title: "教学系统下载"
      }
    },
    // {
    //   path: '/test',
    //   component: test,
    //   meta: {
    //     title: "首页"
    //   }
    // },
    // {
    //   path: '/act_code1',
    //   component: act_code1,
    //   meta: {
    //     title: "返回激活"
    //   }
    // },
    {
      path: '/read',
      name: 'read',
      component: read,
      meta: {
        title: "线上课程—麻吉星MAJIXING"
      }
    },
    {
      path: '/coursedetails',
      name: 'coursedetails',
      component: coursedetails,
      meta: {
        title: "线上课程—麻吉星MAJIXING",
        needShare:true,
        needQuery:true
      }
    },
    {
      path: '/listencourse',
      name: 'listencourse',
      component: ListenCourse,
      meta: {
        title: "线上课程—麻吉星MAJIXING",
        needShare:true,
        needQuery:true
      }
    },
    // {
    //   path: '/BookList',
    //   name: 'BookList',
    //   component: BookList,
    //   meta: {
    //     title: "线上课程—麻吉星MAJIXING"
    //   }
    // },
    {
      path: '/tiaozhuan',
      name: 'tiaozhuan',
      component: tiaozhuan
    },
    {
      path: '/policy',
      name: 'policy',
      component: policy,
      meta: {
        title: "版权协议—麻吉星MAJIXING"
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
      meta: {
        title: "隐私政策—麻吉星MAJIXING"
      }
    },
    {
      path: '/softwareDownload',
      name: 'softwareDownload',
      component: softwareDownload,
      meta: {
        title: "软件下载",
      }
    },
    {
      path: '/productPage',
      name: 'productPage',
      component: productPage,
      meta: {
        title: "产品彩页"
      }
    },
    {
      path: '/productTutorial',
      name: 'productTutorial',
      component: productTutorial,
      meta: {
        title: "产品教程",
        needShare:true
      }
    },
    {
      path: '/productTutorialInfo',
      name: 'productTutorialInfo',
      component: productTutorialInfo,
      meta: {
        title: "产品教程",
        needShare:true,
        needQuery:true
      }
    },
    {
      path: '/question',
      name: 'question',
      component: question,
      meta: {
        title: "常见问题"
      }
    },
    {
      path: '/lessonSelection',
      name: 'lessonSelection',
      component: lessonSelection,
      meta: {
        title: "精选课例",
        needShare:true
      }
    },
    {
      path: '/lessonSelectionInfo',
      name: 'lessonSelectionInfo',
      component: lessonSelectionInfo,
      meta: {
        title: "精选课例",
        needShare:true,
        needQuery:true
      }
    },
    {
      path: '/questionInfo',
      name: 'questionInfo',
      component: questionInfo,
      meta: {
        title: "常见问题",
        needQuery:true
      }
    },
    {
      path: '/expertForm',
      name: 'expertForm',
      component: expertForm,
      meta: {
        title: "专家论坛",
        needShare:true
      }
    },
    {
      path: '/expertFormList',
      name: 'expertFormList',
      component: expertFormList,
      meta: {
        title: "专家论坛",
        needShare:true
      }
    },
    {
      path: '/expertFormInfo',
      name: 'expertFormInfo',
      component: expertFormInfo,
      meta: {
        title: "专家论坛",
        needShare:true,
        needQuery:true
      }
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: pdf,
      meta: {
        title: "产品彩页",
        is_foot:true,
        is_header:true,
        needShare:true,
        needQuery:true
      }
    },
    // 404页面
    {
      path: '*',
      name: 'Home',
      component: Home,
      meta: {
        title: "麻吉星・MAJIXING"
      }
    }
  ],
});
export default router;
router.beforeEach((to, from, next) => {
  if(to.path!=='/questionInfo'&&to.path!=='/question'){
    sessionStorage.removeItem('type');
  }
  if(to.path!=='/news_info'&&to.path!=='/news_list'){
    sessionStorage.removeItem('news_current_page');
  }
  if(to.path!=='/SchoolList'&&to.path!=='/SchoolInfo'){
    sessionStorage.removeItem('school_current_page');
  }
  if(to.path!=='/lessonSelection'&&to.path!=='/lessonSelectionInfo'&&to.path!=='/login'){
    sessionStorage.removeItem('lesson_obj');
    sessionStorage.removeItem('keyword');
  }
  if(to.path!=='/AllWork'&&to.path!=='/hot'&&to.path!=='/idiom'&&to.path!=='/create'&&to.path!=='/VideoInfo'){
    sessionStorage.removeItem('tuijian_current_page');
    sessionStorage.removeItem('hot_current_page');
    sessionStorage.removeItem('idiom_current_page');
    sessionStorage.removeItem('create_current_page');
  }

  let token = localStorage.getItem('token');
  let needLogin = to.meta.needLogin;
  if(token&&needLogin===1){
    next({path:'/'})
  }else if(!token&&needLogin===2){
    next({path:'/'})
  }else if(to.meta.needQuery&&JSON.stringify(to.query)==='{}'){
    next({path:'/'})
  }else{
    next()
  }
});
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };



// WEBPACK FOOTER //
// ./src/router/index.js